'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Components


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = require('react-dnd');

var _ElementDragLayer = require('./ElementDragLayer');

var _ElementDragLayer2 = _interopRequireDefault(_ElementDragLayer);

var _elementConstants = require('../../../common/elements/elementConstants');

require('./WorkspaceDragLayer.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var workspaceDragLayerConnect = function workspaceDragLayerConnect(monitor) {
    return {
        isDragging: monitor.isDragging(),
        itemType: monitor.getItemType()
    };
};

var WorkspaceDragLayer = (_dec = (0, _reactDnd.DragLayer)(workspaceDragLayerConnect), _dec(_class = function (_React$Component) {
    _inherits(WorkspaceDragLayer, _React$Component);

    function WorkspaceDragLayer() {
        _classCallCheck(this, WorkspaceDragLayer);

        return _possibleConstructorReturn(this, (WorkspaceDragLayer.__proto__ || Object.getPrototypeOf(WorkspaceDragLayer)).apply(this, arguments));
    }

    _createClass(WorkspaceDragLayer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                isDragging = _props.isDragging,
                currentBoardId = _props.currentBoardId,
                itemType = _props.itemType;

            if (!isDragging && itemType !== _elementConstants.ELEMENT_DND_TYPE) return null;

            return _react2.default.createElement(
                'div',
                { className: 'WorkspaceDragLayer' },
                _react2.default.createElement(_ElementDragLayer2.default, { currentBoardId: currentBoardId })
            );
        }
    }]);

    return WorkspaceDragLayer;
}(_react2.default.Component)) || _class);


WorkspaceDragLayer.propTypes = {
    currentBoardId: _propTypes2.default.string,
    isDragging: _propTypes2.default.bool,
    itemType: _propTypes2.default.string
};

exports.default = WorkspaceDragLayer;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/dnd/WorkspaceDragLayer.js
// module id = 2160
// module chunks = 0